import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const mapHeight = '265px';

export const DashboardContainerStyled = styled.div`
  overflow-y: hidden;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const DashboardPersonaContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const WeldDashboardLeftSectionStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  ${({ theme }) => css`
    position: relative;
    margin-right: ${theme.spacings[550]};
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 16%);
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[400]};
    width: 65%;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      width: 100%;
      margin-right: ${theme.spacings[500]};
    }
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      margin-right: ${theme.spacings[400]};
    }
  `};
`;

export const WeldDashboardRightSectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    width: 35%;
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      width: 32%;
    }
  `};
`;

export const DashboardPersonaContentStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  overflow-y: hidden;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const WeldSectionListStyled = styled(Box).attrs({ pb: { sm: '300' }, px: { sm: '600' } })`
  height: 100%;
  overflow-y: hidden;
`;

export const WeldListStyled = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `};
`;

export const CarouselContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  overflow: auto;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `};
`;

export const MapContainerStyled = styled(Box)`
  height: ${mapHeight};
`;
